import api from './api';

// ── Admin endpoints ───────────────────────────────────────────────────────────
export const getFeeStructure      = ()              => api.get('/api/fees/structure');
export const updateFeeStructure   = (data)          => api.put('/api/fees/structure', data);
export const getStudentsForPayment= ()              => api.get('/api/fees/students');
export const getAllPayments        = (params)        => api.get('/api/fees/all', { params });
export const getPaymentSummary    = (month)         => api.get('/api/fees/summary', { params: { month } });
export const generateMonthlyFees  = (month)         => api.post('/api/fees/generate', { month });
// Accepts plain JSON or FormData (when a payment proof file is attached).
export const recordPayment        = (data)          =>
  data instanceof FormData
    ? api.post('/api/fees/record', data, { headers: { 'Content-Type': 'multipart/form-data' } })
    : api.post('/api/fees/record', data);
export const addCustomCharge      = (data)          => api.post('/api/fees/custom-charge', data);
export const giveDiscount         = (data)          => api.post('/api/fees/discount', data);
export const removeDiscount       = (id)            => api.delete(`/api/fees/${id}/discount`);
export const updatePayment        = (id, data)      => api.put(`/api/fees/${id}`, data);
export const confirmPayment       = (id, data)      => api.put(`/api/fees/confirm/${id}`, data);
export const waivePayment         = (id, data)      => api.put(`/api/fees/waive/${id}`, data);
export const sendReceiptEmail     = (id)            => api.post(`/api/fees/${id}/send-receipt`);
export const getReceipt           = (id)            => api.get(`/api/fees/${id}/receipt`);
export const sendAllReminders     = (month)         => api.post('/api/fees/remind-all', { month });

// ── Student endpoints ─────────────────────────────────────────────────────────
export const getMyFees            = ()              => api.get('/api/fees/my');
export const initiatePayment      = (data)          => api.post('/api/fees/pay', data);
export const submitProof          = (formData)      => api.post('/api/fees/submit-proof', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// ── Payment settings ──────────────────────────────────────────────────────────
export const getPaymentSettings   = ()              => api.get('/api/fees/payment-settings');
export const updatePaymentSettings= (data)          => api.put('/api/fees/payment-settings', data);
export const uploadQrImage        = (method, fd)    => api.post(`/api/fees/payment-settings/qr/${method}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
export const removeQrImage        = (method)        => api.delete(`/api/fees/payment-settings/qr/${method}`);

// ── Admin proof review ────────────────────────────────────────────────────────
export const getProofsForReview   = (params)        => api.get('/api/fees/proofs', { params });
export const approveProof         = (id, data)      => api.put(`/api/fees/${id}/approve-proof`, data);
export const rejectProof          = (id, reason)    => api.put(`/api/fees/${id}/reject-proof`, { reason });

// ── Parent payment link ───────────────────────────────────────────────────────
export const generatePaymentLink  = (paymentId)     => api.post(`/api/fees/${paymentId}/generate-link`);
export const sendReminderEmail    = (paymentId)     => api.post(`/api/fees/${paymentId}/send-reminder-email`);

// ── Public endpoints (no auth needed) ────────────────────────────────────────
export const getPublicPayment     = (token)         => api.get(`/api/public/pay/${token}`);
export const submitPublicProof    = (token, fd)     => api.post(`/api/public/pay/${token}/submit`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
